import React from "react";
import SorensenXgControl from "./vendors/sorensen-xg/SorensenXgControl";
import SpellmanIcaControl from "./vendors/spellman-ica/SpellmanIcaControl";
import PeakComARU2856CControl from "./vendors/peak-com-aru2856c/PeakComARU2856CControl";

export default function PipeControl({pipe, handleSettingsChanged, handleSettingsApply, handleActionsApply}) {
    switch (pipe.vendor) {
        case "SORENSEN_XG":
            return <SorensenXgControl pipe={pipe}
                                      handleSettingsChanged={handleSettingsChanged}
                                      handleSettingsApply={handleSettingsApply}
                                      handleActionsApply={handleActionsApply}
            />;

        case "SPELLMAN_ICA":
            return <SpellmanIcaControl pipe={pipe}
                                       handleSettingsChanged={handleSettingsChanged}
                                       handleSettingsApply={handleSettingsApply}
                                       handleActionsApply={handleActionsApply}
            />;

        case "PEAK_COM_ARU2856C":
            return <PeakComARU2856CControl pipe={pipe}
                                           handleSettingsChanged={handleSettingsChanged}
                                           handleSettingsApply={handleSettingsApply}
                                           handleActionsApply={handleActionsApply}
            />;

        default:
            return null;
    }
}